//   /**Qty Increament */
// $(document).on("click",".js-product-qty",function() {
//     $(this).parents('.js-qty-wrap').find('input').attr('disabled',false)
//     $(this).parents('.js-qty-wrap').find('.js-minus-qty').attr('disabled', false)
// const valchange = parseInt($(this).parents('.js-qty-wrap').find('input.variant').val()) + 1;
// const maxVal = parseInt($(this).parents('.js-qty-wrap').find('input.variant').attr('max'));
// $(this).parents('.js-qty-wrap').find('input.variant').val(valchange);
// if(valchange >= maxVal){
//     $(this).attr('disabled',true)
// }else{
//      $(this).attr('disabled',false)
// }
// });
//   /**Qty Decreament */
// $(document).on("click",".js-minus-qty",function() {
//     $(this).parents('.js-qty-wrap').find('.js-product-qty').attr('disabled', false)
// const valchange = parseInt($(this).parents('.js-qty-wrap').find('input.variant').val()) - 1;
// const maxVal = parseInt($(this).parents('.js-qty-wrap').find('input.variant').attr('max'));
// $(this).parents('.js-qty-wrap').find('input.variant').val(valchange);
//     if(valchange == 0){
//         $(this).attr('disabled',true)
//             $(this).parents('.js-qty-wrap').find('input').attr('disabled',true)
//     }else{
//         $(this).attr('disabled',false)
//             $(this).parents('.js-qty-wrap').find('input').attr('disabled',false)
//     }
// });
//   /**All Qty Increament */
// $(document).on("click",".bulk-plus",function() {
//     $('.bulk-minus').attr('disabled',false);
//     const valchange = parseInt($(this).parents('.bulk-total').find('input').val()) + 1;
//     $(this).parents('.bulk-total').find('input').val(valchange);
//     $('.js-product-qty').trigger('click');
//  });

//     /**All Qty Decreament */
// $(document).on("click",".bulk-minus",function() {
//     $('.bulk-plus').attr('disabled',false);   
//     const valchange = parseInt($(this).parents('.bulk-total').find('input').val()) - 1;
//     $(this).parents('.bulk-total').find('input').val(valchange);
//     $('.js-minus-qty').trigger('click');
//     if(valchange == 0){
//         $(this).parents('.bulk-total').find('input').val(0)
//         $(this).attr('disabled',true)
//     }else {
//     $(this).attr('disabled',false)
//     }
// });

function updateQtyUI($wrap){
  let $input = $wrap.find("input.variant");
  let val = parseInt($input.val()) || 0;
  let maxVal = parseInt($input.attr("max")) || 999;
  if(val > maxVal) val = maxVal;
  if(val < 0) val = 0;
  $input.val(val);
  if(val >= maxVal){
    $wrap.find(".js-product-qty").attr("disabled", true);
  } else {
    $wrap.find(".js-product-qty").attr("disabled", false);
  }
  if(val <= 0){
    $wrap.find(".js-minus-qty").attr("disabled", true);
  } else {
    $wrap.find(".js-minus-qty").attr("disabled", false);
  }
}

/** Single Qty Keyboard Input */
$(document).on("input", ".js-qty-wrap input.variant", function () {
  let $wrap = $(this).closest(".js-qty-wrap");
  updateQtyUI($wrap);
});


/** Qty Increment */
$(document).on("click", ".js-product-qty", function () {
  let $wrap = $(this).closest(".js-qty-wrap");
  let $input = $wrap.find("input.variant");
  let val = parseInt($input.val()) || 0;
  let maxVal = parseInt($input.attr("max")) || 999;
  if(val < maxVal){
    $input.val(val + 1);
  }
  updateQtyUI($wrap);
});


/** Qty Decrement */
$(document).on("click", ".js-minus-qty", function () {
  let $wrap = $(this).closest(".js-qty-wrap");
  let $input = $wrap.find("input.variant");
  let val = parseInt($input.val()) || 0;
  if(val > 0){
    $input.val(val - 1);
  }
  updateQtyUI($wrap);
});


/** Bulk Plus */
$(document).on("click", ".bulk-plus", function () {
  let $bulkWrap = $(this).closest(".bulk-total");
  let $bulkInput = $bulkWrap.find("input");
  let bulkVal = parseInt($bulkInput.val()) || 0;
  bulkVal++;
  $bulkInput.val(bulkVal);
  $(".js-qty-wrap").each(function(){
    let $wrap = $(this);
    let $input = $wrap.find("input.variant");
    let maxVal = parseInt($input.attr("max")) || 999;
    $input.val(Math.min(bulkVal, maxVal));
    updateQtyUI($wrap);
  });
  $(".bulk-minus").attr("disabled", false);
});


/** Bulk Minus */
$(document).on("click", ".bulk-minus", function () {
  let $bulkWrap = $(this).closest(".bulk-total");
  let $bulkInput = $bulkWrap.find("input");
  let bulkVal = parseInt($bulkInput.val()) || 0;
  bulkVal--;
  if(bulkVal < 0) bulkVal = 0;
  $bulkInput.val(bulkVal);
  $(".js-qty-wrap").each(function(){
    let $wrap = $(this);
    let $input = $wrap.find("input.variant");
    let maxVal = parseInt($input.attr("max")) || 999;
    $input.val(Math.min(bulkVal, maxVal));
    updateQtyUI($wrap);
  });
  if(bulkVal == 0){
    $(this).attr("disabled", true);
  } else {
    $(this).attr("disabled", false);
  }
  $(".bulk-plus").attr("disabled", false);
});


/** Bulk Keyboard Input */
$(document).on("input", ".bulk-total input", function () {
  let bulkVal = parseInt($(this).val()) || 0;
  if(bulkVal < 0) bulkVal = 0;
  $(this).val(bulkVal);
  $(".js-qty-wrap").each(function(){
    let $wrap = $(this);
    let $input = $wrap.find("input.variant");
    let maxVal = parseInt($input.attr("max")) || 999;
    $input.val(Math.min(bulkVal, maxVal));
    updateQtyUI($wrap);
  });
  if(bulkVal == 0){
    $(".bulk-minus").attr("disabled", true);
  } else {
    $(".bulk-minus").attr("disabled", false);
  }
  $(".bulk-plus").attr("disabled", false);
});

$(document).on("click", "#clearAll", function () {
  $(".bulk-total input").val(0);  
  $(".js-qty-wrap").each(function () {
    let $wrap = $(this);
    $wrap.find("input.variant").val(0);
    updateQtyUI($wrap);
  });
  $(".bulk-minus").attr("disabled", true);
  $(".bulk-plus").attr("disabled", false);
});

$(document).on("click", ".button.show-more", function () {
    $('.variant-bulk-table .rest-product').show();
    $('.button.show-less').show();
    $(this).hide()
});
$(document).on("click", ".button.show-less", function () {
    $('.variant-bulk-table .rest-product').hide();
    $('.button.show-more').show();
    $(this).hide(); 
    $('html, body').animate({
        scrollTop: $('.variant-bulk-table').offset().top - 20
    }, 600);
});

$(document).on("keyup", "#variantSearch", function () {
  let searchVal = $(this).val().toLowerCase().trim();
   $('.variant-bulk-table .rest-product').show();
     $('.button.show-less').show();
      $('.button.show-more').hide();
  $("#variantTableBody tr.variant-row").each(function () {
    let rowText = $(this).attr("data-title").toLowerCase();
    if (rowText.indexOf(searchVal) > -1) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });


 
});








